import { IAppState } from '../../store';

export const selectChatStatistics = (state: IAppState) => state.chatStatistics;
